module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex add-image bg-medium pointer p-5 radius-top-left-normal radius-top-right-normal",
    style: ('background-image : url(' + _vm.bannerBackground + ')'),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.upload($event)
      }
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('button', {
    staticClass: "btn secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.upload($event)
      }
    }
  }, [_vm._v("\n            Edit Picture\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "fs-small dark mt-2 text-center"
  }, [(!_vm.isFormatOk) ? _c('div', [_vm._v("Image format must be JPG or PNG.")]) : _vm._e(), _vm._v(" "), (!_vm.isSizeOk) ? _c('div', [_vm._v("Image max size is " + _vm._s(_vm.sizeLimit) + "Mb.")]) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "inputAvatarUpload",
    staticClass: "hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.receiveImage
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-22b23f2a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22b23f2a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/ProductAddImage.vue
// module id = 1009
// module chunks = 0